import { useTranslate } from '../../hooks/useTranslate.jsx';
import { useCEProductCustomization } from '../../bitf-customization-engine/useCEProductCustomization';

export default function CECustomizationButton({
  language = 'it',
  ariaControls = 'product-customization-drawer-pdp',
  storeName = 'shared',
}) {
  const { translate } = useTranslate(language);
  const { store } = useCEProductCustomization({
    storeName: storeName,
    watchStoreChanges: false,
  });

  const handleClick = () => {
    // Find and trigger the drawer
    const drawer = document.getElementById(ariaControls);
    if (drawer) {
      // Trigger the drawer open event (adjust based on your drawer implementation)
      const openEvent = new CustomEvent('dialog:open', {
        bubbles: true,
        cancelable: true,
        composed: true,
      });
      drawer.dispatchEvent(openEvent);
    }
  };

  // Non mostrare il pulsante se la variante non è disponibile
  if (!store?.currentProductVariant?.available) {
    return <></>;
  }

  return (
    <button
      type="button"
      className="om-button button w-full button-secondary product-customization-drawer-pdp__open-button"
      aria-controls={ariaControls}
      onClick={handleClick}
    >
      <span className="om-button__label PrimaryFont Label--L Medium">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.00192 2.65546C6.36925 2.65546 6.66889 2.95513 6.66891 3.32245C6.66891 3.6898 6.36927 3.98944 6.00192 3.98944H4.66891C2.83092 3.98944 1.33395 5.48641 1.33395 7.32441V15.3273C1.33395 17.1653 2.83092 18.6623 4.66891 18.6623H12.6718C14.5098 18.6623 16.0068 17.1653 16.0068 15.3273V13.9934C16.0069 13.6261 16.3065 13.3264 16.6738 13.3264C17.0409 13.3266 17.3407 13.6262 17.3408 13.9934V15.3273C17.3408 17.9013 15.2458 19.9962 12.6718 19.9963H4.66891C2.09496 19.9963 -3.05176e-05 17.9013 -3.05176e-05 15.3273V7.32441C-3.05176e-05 4.75045 2.09496 2.65546 4.66891 2.65546H6.00192ZM15.7334 0.00506939L15.7363 0.00799908C17.9978 0.194463 19.8049 2.00546 19.9951 4.26679C20.0289 4.66393 19.8882 5.05707 19.6084 5.3371L12.041 12.9045C10.9068 14.0374 9.40001 14.6612 7.79684 14.6613H7.33884C6.23569 14.6611 5.33884 13.7635 5.33884 12.6603V12.2033C5.33885 10.6 5.96242 9.09144 7.09567 7.95819L14.6621 0.391788C14.9421 0.107815 15.3361 -0.0287999 15.7334 0.00506939ZM8.03708 8.90155C7.15658 9.7807 6.66998 10.9559 6.66989 12.2023V12.6603C6.67015 13.0275 6.9697 13.3264 7.33688 13.3264H7.79391C9.04039 13.3263 10.2142 12.8397 11.0947 11.9592L18.6806 4.37226L18.6142 4.02655C18.3577 2.68634 17.3108 1.6388 15.9707 1.38202L15.624 1.31562L8.03708 8.90155Z"
            fill="currentColor"
          />
        </svg>
        <span className="PrimaryFont Medium Label--L">{translate('customization.form.customize')}</span>
      </span>
      <span className="om-button__icon-wrapper">
        <svg
          width="20"
          className="icon icon-carousel-arrow-right"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.9766 9.64258L18.335 9.99805L17.9766 10.3535L9.16406 19.085L8.46094 18.374L16.4082 10.498H0V9.49805H16.4082L8.46094 1.62109L8.8125 1.2666L9.16406 0.911133L17.9766 9.64258Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </button>
  );
}
